// extracted by mini-css-extract-plugin
export default {"wrap":"pB-z","logoContainer":"qB-z","brandImg":"rB-z","logoImg":"sB-z","logoButton":"tB-z"};